(function () {
  if (window.upsellBannerExperimentBound || window.Shopify?.designMode) return;
  window.upsellBannerExperimentBound = true;

  function startExperiment() {
    const banner = document.querySelector('.bundle-upsell[data-product-viewed]');
    const source = banner?.closest('.shopify-section');
    const tabs = document.querySelector('.tab-customize, .mobile-show button[data-product-info-tab]');
    const target = tabs?.closest('.shopify-section');

    if (!source || !target || source === target || source.parentNode !== target.parentNode) return;

    const previousDisplay = source.style.display;
    source.style.display = 'none';
    const deadline = Date.now() + 2000;
    let finished = false;

    function finish(variant) {
      if (finished) return;
      finished = true;
      let assignment = 'unassigned';
      let position = 'current';

      try {
        if (variant === 'treatment') {
          target.parentNode.insertBefore(source, target);
          assignment = 'treatment';
          position = 'above_tabs';
        } else if (variant === 'control') {
          assignment = 'control';
        }

        window.upsellBannerExperiment = { variant: assignment, position: position };
        if (typeof window.mixpanel?.register === 'function') {
          window.mixpanel.register({
            upsell_banner_variant: assignment,
            upsell_banner_position: position
          }, { persistent: false });
        }
      } finally {
        source.style.display = previousDisplay;
      }
    }

    function checkFlag() {
      if (Date.now() >= deadline) {
        finish('unassigned');
        return;
      }

      try {
        const flags = window.mixpanel?.flags;
        if (typeof flags?.are_flags_ready === 'function' && flags.are_flags_ready() &&
            typeof flags.get_variant_sync === 'function') {
          const variant = flags.get_variant_sync('upsell_banner', { key: 'unassigned', value: 'unassigned' });
          const value = variant.value === 'control' || variant.value === 'treatment' ? variant.value : variant.key;
          finish(value);
          return;
        }
      } catch (error) {
        finish('unassigned');
        return;
      }

      setTimeout(checkFlag, 50);
    }

    checkFlag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startExperiment, { once: true });
  } else {
    startExperiment();
  }
})();
